import React from 'react';

interface ShotClockControlsProps {
    clockRunning: boolean;
    /** Whether the clock has time left to start (main and shot both > 0). */
    canRun: boolean;
    /** 18-reset is only valid when the shot clock is at/below 18 (bump up, never down). */
    canReset18: boolean;
    onToggle: () => void;
    onReset28: () => void;
    onReset18: () => void;
}

/**
 * Big start/stop (runs/pauses both clocks) plus the two shot-clock resets:
 * 28 (full, also flips possession) and 18 (partial).
 */
const ShotClockControls: React.FC<ShotClockControlsProps> = ({
    clockRunning,
    canRun,
    canReset18,
    onToggle,
    onReset28,
    onReset18,
}) => (
    <div className="m-clkctl">
        <button
            type="button"
            className={`m-startstop2 ${
                clockRunning ? 'm-startstop2--running' : 'm-startstop2--stopped'
            }`}
            disabled={!clockRunning && !canRun}
            onClick={onToggle}
            aria-label={clockRunning ? 'Stop' : 'Start'}
        >
            <span className={clockRunning ? 'm-ic-stop' : 'm-ic-play'} />
        </button>

        <div className="m-resets">
            <button type="button" className="m-reset" onClick={onReset28}>
                <span className="m-reset__icon">&#8635;</span>
                <span className="m-reset__num">28</span>
            </button>
            <button type="button" className="m-reset" disabled={!canReset18} onClick={onReset18}>
                <span className="m-reset__icon">&#8635;</span>
                <span className="m-reset__num">18</span>
            </button>
        </div>
    </div>
);

export default ShotClockControls;
